import { EnableLspActionKey } from "../../actions/ActionKeys";
import { SetEnableLsp } from "../../actions/enableLsp";

export const enableLsp = (
  state: boolean = false,
  action: SetEnableLsp
): boolean => {
  switch (action.type) {
    case EnableLspActionKey.SET_ENABLE_LSP:
      return action.payload.enableLsp;
    default:
      return state;
  }
};
